import { render } from "./AsInput.vue?vue&type=template&id=12522aa6&ts=true"
import script from "./AsInput.vue?vue&type=script&lang=ts"
export * from "./AsInput.vue?vue&type=script&lang=ts"

import "./AsInput.vue?vue&type=style&index=0&id=12522aa6&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__